import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../constants';

const Sponsor = styled.div`
    padding: 0.5rem;
    display: flex;
    align-items: center;
    flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
    h4 {
        ${(props) =>
            props.vertical
                ? `text-align: center; margin-bottom: 1rem`
                : `margin-right: 1rem`};
    }
    a {
        margin: 0 auto;
    }
    @media (max-width: ${breakpoints.mobile}) {
        display: block;
        text-align: center;
        h4 {
            margin-right: 0;
            margin-bottom: 1rem;
        }
    }
`;

export default ({
    style,
    className,
    title,
    url,
    img,
    maxHeight = 0,
    vertical = false,
}) => (
    <Sponsor style={style} className={className} vertical={vertical}>
        {title && <h4>{title}</h4>}
        <a href={url}>
            <img src={img} style={{ maxHeight: maxHeight || 'auto' }} />
        </a>
    </Sponsor>
);



// WEBPACK FOOTER //
// ./src/components/Sponsor.js